<template>
  <a target="_blank" :href="links[name]" class="app-course">
    <i class="icon-course"></i>教程
  </a>
</template>
<script>
export default {
  name: "Course",
  props: ["name"],

  data() {
    return {
      links: {
        hotspot: "//ke.5118.com/detail/75ec1e45-87ee-ea11-8db9-801844e28781",
        article: "//ke.5118.com/detail/792bd711-89ee-ea11-8db9-801844e28781",
        Relevant_paragraphs:
          "//ke.5118.com/detail/2b68de8b-88ee-ea11-8db9-801844e28781",
        Extended_demand:
          "//ke.5118.com/detail/b2275246-89ee-ea11-8db9-801844e28781",
        high_frequency:
          "//ke.5118.com/detail/4052cbd6-88ee-ea11-8db9-801844e28781",
        Collection: "//ke.5118.com/detail/85375608-88ee-ea11-8db9-801844e28781",
        doc: "//ke.5118.com/detail/7f123923-8aee-ea11-8db9-801844e28781",
        style: "//ke.5118.com/detail/88dbabb6-7eee-ea11-8db9-801844e28781",
        imges: "//ke.5118.com/detail/c8876bed-89ee-ea11-8db9-801844e28781",
        Editor: "//ke.5118.com/detail/c50c2386-87ee-ea11-8db9-801844e28781",
        intelligence:
          "//ke.5118.com/detail/bf3716b9-8bee-ea11-8db9-801844e28781",
        wycUrl: "//ke.5118.com/detail/421322a5-8cee-ea11-8db9-801844e28781",
        abstract: "//ke.5118.com/detail/431322a5-8cee-ea11-8db9-801844e28781",
        error: "//ke.5118.com/detail/cd1dd2df-8bee-ea11-8db9-801844e28781",
        oriCheck: "//ke.5118.com/detail/2a21c867-8bee-ea11-8db9-801844e28781",
        violation: "//ke.5118.com/detail/c4c9706d-8aee-ea11-8db9-801844e28781",
        replaceWyc: "//ke.5118.com/detail/1a19387f-3659-eb11-8dba-801844e28781"
      }
    };
  }
};
</script>
<style lang="less" scoped>
.app-course {
  color: #216bed;
  font-size: 14px;
  line-height: 16px;
  float: right;
  margin-right: 20px;
}
.icon-course {
  display: inline-block;
  font-size: 0;
  background: url("../../assets/image/course.png") no-repeat;
  width: 16px;
  height: 16px;
  vertical-align: bottom;
  margin-right: 5px;
}
</style>
